globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalWhiteSpacesDocument = (function(superClass)
{
    utils.extend(ModalWhiteSpacesDocument, superClass);

    function ModalWhiteSpacesDocument($html) {
      return ModalWhiteSpacesDocument.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalWhiteSpacesDocument.prototype, {
      init: function() {
        $(".styled").uniform({ radioClass: 'choice' });

        var defaults = {
          showDropdowns: true,
          autoApply: true,
          autoUpdateInput: false,
          locale: {
            format: 'DD/MM/YYYY'
          }
        }
        $('.datepicker').each(function() {
          var $this = $(this),
              options = $this.data('daterangepicker-options') || {};
          defaults.singleDatePicker = true;
          $this.daterangepicker(
            $.extend({}, defaults, options),
            function(start, end, label) {
              $this.val(start._d.toLocaleDateString());

              window.preventHidingDropdowns = true;
            }
          );
        });

        this.$html.on('hidden.bs.modal', (function(_this) {
          return function() {
            return _this.close();
          };
        })(this));

        this.$html.find('button.submit').click((function(_this) {
          return function() {
            backoffice.loader.start();
            _this.submit();
            this.close();
            return false;
          };
        })(this));
      },
      callbackSuccess: function(data) {
        ModalWhiteSpacesDocument.__super__.callbackSuccess.apply(this, arguments);
      }
    });

    return ModalWhiteSpacesDocument;
})(backoffice.ModalMain);
